module.exports = {"name":"chromecast","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.0.0","built":"2017-10-18","repo":"https://bitbucket.org/npaw/chromecast-adapter-js","libVersion":"^6.0.4","features":{"buffer":"native","seek":"native","getters":["getPlayhead","getPlayrate","getFramesPerSecond","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getTitle2","getIsLive","getResource","getPosition"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0